<template>
	<div class="m-1">
		<b-modal ref="tip-modal" size="sm" id="modal-center" centered hide-footer  hide-title
			title="提示">
			<div class="d-flex justify-content-center p-2">
				<span class="text-primary">支付满10元可享随机减免优惠。</span>
			</div>
		</b-modal>
	</div>
</template>
<script>
	export default {
		components: {
		},
		data() {
			return {
			
			}
		},

		methods: {
			showModal() {
			
				this.$refs['tip-modal'].show()
			
			},
		
			hideModal() {
				this.$refs['tip-modal'].hide()
			},
		}

	}
</script>

<style>

</style>
